import { container } from "tsyringe";
import { SentryContext } from "./sentry-context";
import type { BrowserClient, Scope } from "@sentry/browser";
import { isOdysseyEnabled } from "./odyssey";

type Sentry = BrowserClient & Scope;
declare let window: Window & {
  fandomSentry?: Sentry;
};

function getSentry(): Promise<Sentry | null> {
  const sentryContext = container.resolve(SentryContext);
  return new Promise((resolve) => {
    if (!sentryContext.isSupported()) {
      resolve(null);
    }

    if (window.fandomSentry) {
      resolve(window.fandomSentry);
    } else {
      window.addEventListener("fandomSentryLoaded", () => {
        resolve(window.fandomSentry!);
      });
    }
  });
}

export async function reportError(error: unknown) {
  // No Odyssey - no window.fandomSentry - at least for now
  if (!isOdysseyEnabled(window)) {
    return;
  }

  const sentry = await getSentry();
  if (!sentry) {
    return;
  }
  const sentryContext = container.resolve(SentryContext);
  sentryContext.setTags(sentry);
  sentry.captureException(error);
}
